import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useStateParams<T extends { [key: string]: string }>() {
  const [params, setParams] = useSearchParams();

  function replace(key: keyof T, value: string) {
    const current: T = {} as T;
    for (const [key, value] of params.entries()) {
      current[key as keyof T] = value as T[keyof T];
    }
    setParams({ ...current, [key]: value });
  }

  const values = useMemo(() => {
    const v: T = {} as T;
    for (const [key, value] of params.entries()) {
      v[key as keyof T] = value as T[keyof T];
    }
    return v;
  }, [params]);

  return {
    setValue: (key: keyof T, value: string) => replace(key, value),
    values
  };
}
